<template>
<div class="divSelectModeLiv">
    <h4 class="titre">Choisissez votre mode de livraison</h4>
    <div class="listModeLiv">
        <div class="modeLiv" @click="selectModeLiv('retrait')" id="modeRetrait">
            <h5 class="mlTitre">Retrait dans nos locaux</h5>
            <p class="address">1015 Rue du Maréchal Juin, Vaux-Le-Pénil, France</p>
            <img class="mlImg" src="https://preprod.api.defipix.fr/ressource/reservation/image/retraitLocaux200x160.png">
            <p class="mlDesc">Retrait et retour de votre défipix dans nos locaux</p>
            <h5 class="mlPrix" v-if="$store.getters.reservation_client.client.typeClient === 'Particulier' && $store.getters.reservation_client.borne.name == 'Mini' || $store.getters.reservation_client.client.typeClient === 'Particulier' && $store.getters.reservation_client.borne.name == 'Ring'">0€</h5>
            <h5 class="mlPrix" v-if="$store.getters.reservation_client.client.typeClient === 'Professionnel' && $store.getters.reservation_client.borne.name == 'Mini' || $store.getters.reservation_client.client.typeClient === 'Professionnel' && this.$store.getters.reservation_client.borne.name == 'Ring'">{{ Number(0).toFixed(2) }}€ HT</h5>
            <h5 class="mlPrix indisponible" v-if="this.$store.getters.reservation_client.borne.name == 'Miroir'">Indisponible pour cette borne</h5>
        </div>
        <div class="modeLiv" @click="selectModeLiv('livraison')" id="modeLivraison">
            <h5 class="mlTitre">Livraison</h5>
            <p class="address">{{ this.$store.getters.reservation_client.evenement.adresse }} ({{ distance }} km)</p>
            <img v-if="distance > 70" class="mlImg" src="https://preprod.api.defipix.fr/ressource/reservation/image/plus70km200x160.png">
            <img v-else-if="distance <= 70" class="mlImg" src="https://preprod.api.defipix.fr/ressource/reservation/image/moins70km200x160.png">
            <img v-else class="mlImg" src="https://preprod.api.defipix.fr/ressource/reservation/image/truck_200_160.png">
            <p class="mlDesc">Livraison, installation et retrait de votre défipix par nos soins</p>
            <h5 class="mlPrix" id="txtLiv" v-if="coutLiv !== null && !isNaN(coutLiv) && $store.getters.reservation_client.client.typeClient === 'Particulier'">{{ coutLiv }}€</h5>
            <h5 class="mlPrix" id="txtLiv" v-if="coutLiv !== null && !isNaN(coutLiv) && $store.getters.reservation_client.client.typeClient === 'Professionnel'">{{ (Number(coutLiv)-Number(coutLiv/5)).toFixed(2) }}€ HT</h5>
            <h5 class="mlPrix" id="txtLiv" v-if="coutLiv !== null && isNaN(coutLiv)">{{ coutLiv }}</h5>
            <img class="mlPrix" id="loader" v-if="coutLiv === null" src="https://preprod.api.defipix.fr/ressource/reservation/image/loader.gif" />
        </div>
        <div class="modeLiv" @click="selectModeLiv('transporteur')" id="modeTransporteur">
            <h5 class="mlTitre">Livraison par transporteur</h5>
            <p class="address">{{ this.$store.getters.reservation_client.evenement.adresse }} ({{ distance }} km)</p>
            <img class="mlImg" src="https://preprod.api.defipix.fr/ressource/reservation/image/livTransporteur200x160.png">
            <p class="mlDesc">Livraison par transporteur à travers toute la France</p>
            <h5 class="mlPrix" v-if="this.$store.getters.reservation_client.borne.name == 'Ring' && $store.getters.reservation_client.client.typeClient === 'Particulier'">150€</h5>
            <h5 class="mlPrix" v-if="this.$store.getters.reservation_client.borne.name == 'Ring' && $store.getters.reservation_client.client.typeClient === 'Professionnel'">{{ (Number(150)-Number(150/5)).toFixed(2) }}€ HT</h5>
            <h5 class="mlPrix indisponible" v-if="this.$store.getters.reservation_client.borne.name == 'Miroir'">Indisponible pour cette borne</h5>
        </div>
    </div>
    <p class="infoLiv">Le tarif de livraison par nos soins est facturé 1€ le kilomètre (aller & retour) arrondit à la cinquentaine supérieure. 
        <br>la distance est calculé selon l'adresse de votre événement depuis Vaux-Le-Pénil.</p>
    <p class="infoLiv errorMsg" v-if="errorMsg">{{ errorMsg }}</p>
    <NavBar :prev="true" />
</div>
</template>

<script>
import NavBar from '@/components/OrderBooth/NavBar'
import axios from 'axios';
import JQuery from 'jquery'
let $ = JQuery

export default {
    data() {
        return {
            coutLiv: null,
            distanceLoading: true,
            distance: null,
            errorMsg: null,
        }
    },
    mounted: function () {
        $('html,body').animate({scrollTop: 0}, 'slow');
        this.getDistanceFromMelun();
        if (this.$store.getters.reservation_client.borne.name == 'Miroir') {
            $("#modeRetrait").css('filter', 'grayscale(0.9)');
        }
        if (this.$store.getters.reservation_client.borne.name != 'Ring') {
            $("#modeTransporteur").css('filter', 'grayscale(0.9)');
        }
    },
    methods: {
        async getDistanceFromMelun() {
            try {
                const response = await axios({
                    method: "get",
                    url: 'https://preprod.api.defipix.fr/ressource/reservation/delivery_distance/' + this.$store.getters.reservation_client.evenement.adresse,
                    timeout: 1000 * 20,
                    headers: {
                        "Content-Type": "application/json"
                    }
                });                
                this.distance = response.data.distance;
                if (response.data.distance > 79) {
                    let kmSup = response.data.distance * 2;
                    let coutSup = kmSup / 50;
                    coutSup = Math.round(coutSup);
                    coutSup = coutSup * 50;
                    if (response.data.distance < coutSup) {
                        coutSup += 50;
                    }
                    //Envoi obligatoire si ring +70km
                    if (this.$store.getters.reservation_client.borne.name == 'Ring' && response.data.distance > 70) {
                        $("#modeLivraison").css('opacity', '0.5');
                        $("#modeLivraison").hover(function() {
                            $(this).css('transform', 'unset');
                            $(this).css('cursor', 'unset');
                        });
                        this.coutLiv = "Lieu de l'evenement trop eloigné de nos locaux";
                    } else {
                        if (coutSup <= 150) {
                            this.coutLiv = 150
                        } else {
                            this.coutLiv = coutSup;
                        }
                    }
                } else {
                    this.coutLiv = 150;
                }
                this.distanceLoading = false;
            } catch (error) {
                this.$store.getters.reservation_client.borne.name == 'Miroir' ? this.coutLiv = 0 : this.coutLiv = 150;
                this.errorMsg = "Impossible de calculer le tarif de la livraison. Si vous choisissez d'être livré, le tarif sera revu par notre équipe."
                console.log(error);
                this.distanceLoading = false;
            }
        },
        selectModeLiv(modeLiv) {
            if (this.distanceLoading) return;
            if (this.distance > 70 && this.$store.getters.reservation_client.borne.name == 'Ring' && modeLiv == "livraison") return;
            if (modeLiv == "transporteur" && this.$store.getters.reservation_client.borne.name != 'Ring') {
                return;
            }
            if (modeLiv == "retrait" && this.$store.getters.reservation_client.borne.name == 'Miroir') {
                return;
            }
            if (modeLiv == "livraison" && !this.coutLiv && this.$store.getters.reservation_client.borne.name == 'Ring') {
                return;
            }
            let livraison = {
                mode: modeLiv,
                price: 0
            }
            switch (modeLiv) {
                case 'transporteur':
                    livraison.price = 150;
                    break;
                case 'retrait':
                    if (this.$store.getters.reservation_client.borne.name == 'Ring') {
                        livraison.price = 0;
                    } else {
                        livraison.price = 0;
                    }
                    break;
                case 'livraison':
                    livraison.price = this.coutLiv;
                    break;
            }

            this.$store.commit('RCsetModeLiv', livraison);
            this.$store.commit('RCetapeNext');
        }
    },
    components: {
        NavBar
    }
}
</script>

<style scoped>
.divSelectModeLiv {
    margin-bottom: 2em;
    background-color: rgb(248, 248, 248);
    border-radius: 10px;
    padding-top: 2em;
    box-shadow: 0px 0px 5px 0px #aaa;  
    background-color: #25327B;
}

.listModeLiv {
    border-radius: 5px;
    display: grid;
    grid-template-columns: auto auto auto;
    grid-gap: 2em;
    width: fit-content;
    margin: auto;
}

.modeLiv {
    flex: 1;
    padding: 2em;
    background-color: #eeeeee;
    box-shadow: 0px 0px 5px 0px #444;
    text-align: center;
    border-radius: 5px;
    max-width: 20em;
    margin: 0.5em auto;
}

.modeLiv:hover {
    transform: scale(1.02);
    cursor: pointer;
}

.mlTitre {
    min-height: 3em;
    color: #25327B;
}

.mlImg {
    margin: 1em auto;
    width: 70%;
}

.mlDesc {
    min-height: 5em;
}

.mlPrix {
    color: #25327B;
}

.indisponible {
    color: red;
}

.infoLiv {    
    color: #fff;
    text-align: center;
    font-size: 14px;
    width: 75%;
    margin: 10px auto;
    color: rgb(202, 202, 202);
}

.errorMsg {
    color: red;
}

.address {
    font-style: italic;
    font-size: 14px;
}

@media only screen and (max-width: 780px) {
    .listModeLiv {
        display: block;
    }

    .modeLiv {
        margin: 2em auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderBooth/Delivery.vue